import type { VodAssetMetas } from '../../data/asset';
import type { KalturaAsset } from '../objects';

export function processVodAssetMetas(metas: KalturaAsset['metas']): VodAssetMetas {
  return {
    ...(metas['MarkerBackgroundColor'] && {
      contentMarkerBackgroundColor: String(metas['MarkerBackgroundColor'].value),
    }),
    ...(metas['ContentMarkerText'] && {
      contentMarkerText: String(metas['ContentMarkerText'].value),
    }),
    ...(metas['MarkerTextColor'] && {
      contentMarkerTextColor: String(metas['MarkerTextColor'].value),
    }),
  };
}
